function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '../../hooks/useErrorHandling';
import { api as oldApi } from '../service';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '../service_methods';
const api = buildService('/claim_groups/{id}/claim_project_reports', {
  only: ['all', 'get', 'create']
});
const claimProjectReportService = {
  base: api,
  useFetchAll: (claimGroupId, setLoading) => {
    const [projects, setProjects] = useState([]);
    const fetchAndSetReports = useErrorHandling(useCallback(async () => {
      setLoading && setLoading(true);
      if (!claimGroupId) return;
      const reportsResponse = await api.all(claimGroupId);
      setProjects([...reportsResponse.claim_project_reports]);
    }, [claimGroupId, setLoading]), useCallback(() => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      fetchAndSetReports();
    }, [fetchAndSetReports]);
    return [projects, setProjects, fetchAndSetReports];
  },
  useGet: function (claimGroupId, reportId, setLoading) {
    let onSuccess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    let query = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    const [project, setProject] = useState(null);
    const fetchAndSetReport = useErrorHandling(useCallback(async () => {
      setLoading && setLoading(true);
      if (!claimGroupId || !reportId) return;
      const projectResponse = await api.get(claimGroupId, reportId, query || {});
      setProject(_objectSpread({}, projectResponse));
      onSuccess && onSuccess(projectResponse);
    }, [claimGroupId, onSuccess, query, reportId, setLoading]), useCallback(() => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      fetchAndSetReport();
    }, [fetchAndSetReport]);
    return [project, setProject, fetchAndSetReport];
  },
  useGetById: _ref => {
    let {
      claimGroupId,
      setLoading,
      onSuccess,
      query
    } = _ref;
    const [project, setProject] = useState(null);
    const fetchAndSetReport = useErrorHandling(useCallback(async reportId => {
      setLoading && setLoading(true);
      if (!claimGroupId || !reportId) return;
      const projectResponse = await api.get(claimGroupId, reportId, query || {});
      setProject(_objectSpread({}, projectResponse));
      onSuccess && onSuccess(projectResponse);
      return projectResponse;
    }, [claimGroupId, onSuccess, query, setLoading]), useCallback(() => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      fetchAndSetReport();
    }, [fetchAndSetReport]);
    return [project, setProject, fetchAndSetReport];
  },
  useUpdateClaimProjectReportName: function (claimGroupId, claimProjectReport) {
    let shouldReturnHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return useErrorHandling(useCallback(async newName => {
      const updatedClaimProjectReport = await claimProjectReportService.update(claimGroupId, _objectSpread(_objectSpread({}, claimProjectReport), {}, {
        project_name: newName
      }));
      return shouldReturnHtml ? updatedClaimProjectReport.project_name_html : updatedClaimProjectReport.project_name;
    }, [claimGroupId, claimProjectReport, shouldReturnHtml]));
  },
  useUpdateClaimProjectReport: (claimGroupId, claimProjectReport) => {
    return useErrorHandling(useCallback(async function () {
      let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let onSuccess = arguments.length > 1 ? arguments[1] : undefined;
      const updatedClaimProjectReport = await claimProjectReportService.update(claimGroupId, {
        id: claimProjectReport.id,
        claim_project_report: _objectSpread({}, params)
      });
      onSuccess();
      return updatedClaimProjectReport;
    }, [claimGroupId, claimProjectReport]));
  },
  useCreate(_ref2) {
    let {
      onSuccess,
      onError,
      onFinally,
      setLoading,
      claimGroupId
    } = _ref2;
    const createModel = serviceMethods.useCreate({
      setLoading,
      onSuccess,
      onError,
      onFinally,
      callback: useCallback(async project => {
        return await api.create(claimGroupId, project);
      }, [claimGroupId])
    });
    return createModel;
  },
  update: (claimGroupId, claim_project_report) => oldApi.update("/claim_groups/".concat(claimGroupId, "/claim_project_reports/").concat(claim_project_report.id), claim_project_report),
  delete: (claimGroupId, reportId) => oldApi.delete("/claim_groups/".concat(claimGroupId, "/claim_project_reports/").concat(reportId)),
  all: params => oldApi.get("/claim_project_reports?".concat(params)),
  get: (claimGroupId, reportId) => oldApi.get("/claim_groups/".concat(claimGroupId, "/claim_project_reports/").concat(reportId))
};
export default claimProjectReportService;